module.exports = __webpack_public_path__ + "media/audio11.dcb22a58.mp3";